import React from "react";
import { motion } from "framer-motion";

// Primary / secondary CTA button. Variant "solid" uses accent bg.
export const Btn = ({ children, variant = "outline", as = "a", className = "", ...props }) => {
  const base =
    "inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-medium tracking-wide transition-colors duration-300 cursor-pointer select-none whitespace-nowrap";
  const styles =
    variant === "solid"
      ? "text-black hover:opacity-90"
      : "border text-[var(--text-primary)] hover:text-[var(--accent-color)] hover:border-[var(--accent-color)]";
  const style =
    variant === "solid"
      ? { background: "var(--accent-color)", borderRadius: "var(--btn-radius)" }
      : { borderColor: "var(--border-color)", borderRadius: "var(--btn-radius)" };
  const Comp = as;
  return (
    <Comp className={`${base} ${styles} ${className}`} style={style} {...props}>
      {children}
    </Comp>
  );
};

export const SectionLabel = ({ children, className = "" }) => (
  <div className={`flex items-center gap-3 text-xs tracking-[0.35em] uppercase ${className}`}
       style={{ color: "var(--text-secondary)" }}>
    <span className="h-px w-8" style={{ background: "var(--accent-color)" }} />
    {children}
  </div>
);

const revealVariants = {
  hidden: { opacity: 0, y: 28 },
  show: { opacity: 1, y: 0 },
};

export const Reveal = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    variants={revealVariants}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay }}
  >
    {children}
  </motion.div>
);
